var _circle, _circle2, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGameChallengesActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 78,
    viewBox: "0 0 80 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 39,
    r: 37,
    fill: "#3B82F6"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 39,
    r: 21,
    fill: "#75A8FC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.8787 36.3787C37.7071 37.5503 37.7071 39.4497 38.8787 40.6213C40.0503 41.7929 41.9497 41.7929 43.1213 40.6213L38.8787 36.3787ZM43.1213 40.6213L71.1213 12.6213L66.8787 8.37868L38.8787 36.3787L43.1213 40.6213Z",
    fill: "#ECEDF1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M56.6544 13.066L67.4922 2.69934L68.3536 3.56066C68.4473 3.65443 68.5 3.78161 68.5 3.91421V9.5C68.5 10.3284 69.1716 11 70 11H75.5858C75.7184 11 75.8456 11.0527 75.9393 11.1464L76.7853 11.9924L65.4441 22.861C65.3511 22.9502 65.2271 23 65.0982 23H61.8866C61.7622 23 61.6423 22.9536 61.5503 22.87L56.6637 18.4276C56.5594 18.3328 56.5 18.1985 56.5 18.0576V13.4273C56.5 13.2908 56.5558 13.1603 56.6544 13.066Z",
    fill: "#ECEDF1",
    stroke: "#ECEDF1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGameChallengesActive);
export default __webpack_public_path__ + "static/media/game-challenges-active.4da6b8c65111615d1b2e1812f2c216bd.svg";
export { ForwardRef as ReactComponent };